module.exports = __webpack_public_path__ + "cd77b2bd5869719185009c26b5a0f88d.svg";